import { notify } from "../../../../../utils/notify";
import { search } from "../../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/v2/empresa`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function getProductTaxNote({
  companyId = "",
  filters = {},
  page = 1,
  perPage = 10,
  orderFields = "",
  orderType = "desc",
}) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(`${path}/${companyId}/notafiscal/produto`);

  Object.entries(filters).forEach(([name, value]) =>
    url.searchParams.append(`filter[${name}]`, value)
  );

  url.searchParams.append("page", page);
  url.searchParams.append("perPage", perPage);
  url.searchParams.append("orderFields", orderFields);
  url.searchParams.append("orderType", orderType);

  return search(decodeURIComponent(url), "GET", headers);
}

export async function getTaxNoteItem({
  companyId = "",
  filters = {},
  relations = "",
  page = 1,
  perPage = 10,
}) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(`${path}/${companyId}/notafiscal/item`);

  Object.entries(filters).forEach(([name, value]) =>
    url.searchParams.append(`filter[${name}]`, value)
  );

  if (relations) url.searchParams.append("relations", relations);

  url.searchParams.append("page", page);
  url.searchParams.append("perPage", perPage);

  return search(decodeURIComponent(url), "GET", headers);
}
